import React from 'react'
import { IoAirplane, IoBoat, IoFileTray, IoGift, IoPencilSharp } from 'react-icons/io5'

const CartProduct = ({ item, openCustomPopup, closeModal, page }) => {
  const editCart = () => {
    closeModal();
    openCustomPopup(item, 'edit');
  }

  return (
    <div className="CartProduct">
      <div className="img">
        <img src={item.image_url} alt="Mangue" />
      </div>

      <div className="more">
        <div className="title">
          <h3>{item.variety}</h3>
          <span className="price">
            {item.total_price}€

            {page == "order" &&
              <span className="icon" onClick={editCart}>
                <IoPencilSharp />
              </span>
            }
          </span>
        </div>

        <div className="custom">
          <div className="category">
            <span className="icon"><IoFileTray /></span>
            {item.quantity} Kg
          </div>

          <div className="category">
            <span className="icon"><IoFileTray /></span>
            calibre {item.caliber}
          </div>
      </div>
    </div>
  </div>
  )
}

export default CartProduct